// extracted by mini-css-extract-plugin
export default {"mainBox":"blog_mainBox__zRElM","BlogBox":"blog_BlogBox__lIsLR","btn":"blog_btn__eDSOD","btnMain":"blog_btnMain__AJofg","btns":"blog_btns__wnBWv","logo":"blog_logo__+B3az"};